export const dataHooks = {
    toggle: 'checkToggle-toggle',
    tooltip: 'checkToggle-tooltip',
};
export const SIZE = {
    SMALL: 'small',
    MEDIUM: 'medium',
};
export const SKIN = {
    STANDARD: 'standard',
    SUCCESS: 'success',
};
//# sourceMappingURL=constants.js.map